import { Grid } from "@mui/material"

const ScheduleADemo = () => {
    return (
        <>
            <Grid item xs={12}>
                <iframe
                    src="https://calendly.com/marketing-sales-brokersalliance/30min"
                    style={{
                        height: '90vh',
                        width: '100%'
                    }}
                >
                </iframe>
            </Grid>
        </>
    )
}

export default ScheduleADemo
